"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeSeriesBarChartWrapped = exports.TimeSeriesBarChart = void 0;
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const ChartWrapper_1 = __importStar(require("../../components/ChartWrapper"));
const Footnotes_1 = require("../../components/Footnotes");
const Sources_1 = require("../../components/Sources");
const utilities_1 = require("../../utilities");
const constants_1 = require("../../utilities/constants");
const types_1 = require("../../utilities/types");
const chart_1 = __importStar(require("./chart"));
exports.TimeSeriesBarChart = chart_1.default;
const constants_2 = require("./constants");
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
const TimeSeriesBarChartWrapped = _ref => {
  let {
    barOptions = constants_2.DEFAULT_BAR_OPTIONS,
    data: rawData,
    dataSeriesOptions: rawDataSeriesOptions = [],
    footerOptions = constants_2.DEFAULT_FOOTER_OPTIONS,
    height = constants_2.DEFAULT_HEIGHT,
    onClick,
    onMouseOut,
    onMouseOver,
    subtitleOptions = constants_2.DEFAULT_SUBTITLE_OPTIONS,
    titleOptions = constants_2.DEFAULT_TITLE_OPTIONS,
    tooltipOptions = constants_2.DEFAULT_TOOLTIP_OPTIONS,
    width = constants_2.DEFAULT_WIDTH,
    xAxisOptions = constants_2.DEFAULT_X_AXIS_OPTIONS,
    yAxisOptions = constants_2.DEFAULT_Y_AXIS_OPTIONS
  } = _ref;
  const optsBar = lodash_1.default.defaultsDeep({}, barOptions, constants_2.DEFAULT_BAR_OPTIONS);
  const optsFooter = lodash_1.default.defaultsDeep({}, footerOptions, constants_2.DEFAULT_FOOTER_OPTIONS);
  const optsSubtitle = lodash_1.default.defaultsDeep({}, subtitleOptions, constants_2.DEFAULT_SUBTITLE_OPTIONS);
  const optsTitle = lodash_1.default.defaultsDeep({}, titleOptions, constants_2.DEFAULT_TITLE_OPTIONS);
  const optsTooltip = lodash_1.default.defaultsDeep({}, tooltipOptions, constants_2.DEFAULT_TOOLTIP_OPTIONS);
  const optsXAxis = lodash_1.default.defaultsDeep({}, xAxisOptions, constants_2.DEFAULT_X_AXIS_OPTIONS);
  const optsYAxis = lodash_1.default.defaultsDeep({}, yAxisOptions, constants_2.DEFAULT_Y_AXIS_OPTIONS);
  const rawDataIdsString = (0, utilities_1.getDataIds)(rawData);
  const rawDataSeriesOptionsIdsString = (0, utilities_1.getDataIds)(rawDataSeriesOptions);
  // transform data
  const {
    data,
    chartData
  } = (0, react_1.useMemo)(() => {
    const datasets = (0, utilities_1.extractDatasets)(rawData);
    const dataSeriesOptions = (0, utilities_1.prepareDataSeriesOptions)(datasets, rawDataSeriesOptions);
    const innerData = (0, utilities_1.parseData)(datasets, dataSeriesOptions, ['name', 'x_type', 'y_type', 'sources']).map(d => ({
      ...d,
      sources: d.sources || [],
      name: d.metric.labelText || d.name,
      tooltipTitle: d.metric.tooltipTitle || d.name
    }));
    const innerChartData = innerData === null || innerData === void 0 ? void 0 : innerData[0];
    return {
      data: innerData,
      chartData: innerChartData
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rawDataIdsString, rawDataSeriesOptionsIdsString]);
  const optsFooterValuesString = Object.values(optsFooter);
  const {
    footnotes,
    sources,
    summary
  } = (0, react_1.useMemo)(() => {
    if (!optsFooter.show) {
      return {
        footnotes: [],
        sources: [],
        summary: ''
      };
    }
    return {
      ...(0, Sources_1.useSources)({
        data,
        chartSources: optsFooter.sources
      }),
      ...(0, Footnotes_1.useFootnotes)({
        data,
        chartFootnotes: optsFooter.footnotes,
        showMetricFootnotes: optsFooter.showMetricFootnotes
      })
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optsFooterValuesString, rawDataIdsString]);
  const chartWidth = (0, react_1.useMemo)(() => width === 'auto' ? undefined : parseInt(width, 10), [width]);
  const chartHeight = (0, react_1.useMemo)(() => height === 'auto' ? '100%' : parseInt(height, 10), [height]);
  if (!rawData || !rawData.length) {
    console.warn('No data was provided.');
    return null;
  }
  return react_1.default.createElement(ChartWrapper_1.default, {
    className: styles_module_css_1.default['time-series-bar-chart-wrapped'],
    fontSize: optsFooter.fontSize,
    footerSources: sources,
    footerSummary: summary,
    footnotes: footnotes,
    height: chartHeight,
    showFooter: optsFooter.show,
    showMetricFootnotes: optsFooter.showMetricFootnotes,
    subtitle: optsSubtitle.text,
    subtitleFontSize: optsSubtitle.fontSize,
    title: optsTitle.text,
    titleFontSize: optsTitle.fontSize,
    width: chartWidth
  }, _ref2 => {
    let {
      chartHeight: innerChartHeight
    } = _ref2;
    return react_1.default.createElement("div", {
      style: {
        marginTop: `${constants_1.DEFAULT_CHART_TOP_PADDING}px`,
        width: '100%'
      }
    }, react_1.default.createElement(chart_1.default, {
      barOptions: optsBar,
      data: chartData,
      height: innerChartHeight - constants_1.DEFAULT_CHART_TOP_PADDING,
      tooltipOptions: optsTooltip,
      xAxisOptions: optsXAxis,
      yAxisOptions: optsYAxis,
      onMouseOver: onMouseOver,
      onMouseOut: onMouseOut,
      onClick: onClick
    }));
  });
};
exports.TimeSeriesBarChartWrapped = TimeSeriesBarChartWrapped;
TimeSeriesBarChartWrapped.propTypes = {
  ...ChartWrapper_1.chartWrapperPropTypes,
  ...lodash_1.default.omit(chart_1.TimeSeriesBarChartPropTypes, ['data']),
  /**
   * Data for the chart.
   * @param datasets Data entries.
   * Each entry contains required params id, name, x_type, y_type and a data array
   * with key/value pairs.
   * Optional params of footnote, sources array and meta array
   * @param sources Data sources in the standard format. (see chartSources for structure)
   */
  data: (0, prop_types_1.oneOfType)([(0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.dataShape)), (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    /** State data entires */
    datasets: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.dataShape)),
    /** Data sources */
    sources: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.sourcesShape))
  }))]).isRequired,
  /**
   * Defines which group and category each data belongs to. Allows override of some properties.
   * @param id {string} data series id
   * @param tooltipTitle {string} title to be used in tooltop
   */
  dataSeriesOptions: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    id: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.number]).isRequired,
    tooltipTitle: prop_types_1.string
  })),
  /**
   * Configuration options for footer
   * @param fontSize {number} font size override of footer text
   * @param footnotes {object[]} footnotes to add to those found in the data
   * @param show {bool} show or hide footer
   * @param showMetricFootnotes {bool} show or hide footnotes from data series
   * @param sources {object[]} sources to add to those found in the data   *
   */
  footerOptions: (0, prop_types_1.shape)({
    fontSize: prop_types_1.number,
    footnotes: ChartWrapper_1.chartWrapperPropTypes.footnotes,
    show: ChartWrapper_1.chartWrapperPropTypes.showFooter,
    showMetricFootnotes: prop_types_1.bool,
    sources: ChartWrapper_1.chartWrapperPropTypes.footerSources
  }),
  /** height of the chart. Set this to 'auto' to fill container,
   * otherwise set the height in px. */
  height: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.number]),
  /**
   * Chart wrapper subtitle options
   * @param fontSize {number} font size of title
   * @param text {string} text to be used as a subtitle
   */
  subtitleOptions: (0, prop_types_1.shape)({
    fontSize: ChartWrapper_1.chartWrapperPropTypes.subtitleFontSize,
    text: ChartWrapper_1.chartWrapperPropTypes.subtitle
  }),
  /**
   * Chart wrapper title options
   * @param fontSize {number} font size of title
   * @param text {string} text to be used as a title
   */
  titleOptions: (0, prop_types_1.shape)({
    fontSize: ChartWrapper_1.chartWrapperPropTypes.titleFontSize,
    text: ChartWrapper_1.chartWrapperPropTypes.title
  }),
  /** width of the chart. Set this to 'auto' to fill container,
   * otherwise set the width in px. */
  width: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.number])
};
exports.default = TimeSeriesBarChartWrapped;